/* eslint-disable @typescript-eslint/naming-convention */
import { Pipe, PipeTransform } from "@angular/core";
import { NewsDto } from "@api";

const CATEGORY_IMAGES: { [key in NewsDto.TypeEnum]: string } = {
  BWA_REPORT_REMINDER: null,
  CHECK_UP_MISSING: null,
  CHECK_UP_REMINDER: null,
  EVENT_REGISTRATION: "assets/news/EVENT_REGISTRATION.png",
  EVENT_REMINDER: null,
  EVENT_SUBSCRIBED: null,
  EVENT_SURVEY: null,
  INCOMING_BOOKING_WEBSITE: "assets/news/INCOMING_BOOKING_WEBSITE.png",
  USER_RECEIVED_NEW_5_STAR_REVIEWS: "assets/news/USER_RECEIVED_NEW_5_STAR_REVIEWS.jpg",
  SUCCESS_REPORT_REMINDER: null,
  USER_FILLED_BWA: "assets/news/USER_FILLED_BWA.png",
  USER_FILLED_SUCCESS_REPORT: "assets/news/USER_FILLED_BWA.png",
  USER_FINISHED_CHALLENGE: "assets/news/USER_FINISHED_CHALLENGE.png",
  USER_HAS_DAILY_RESULTS_ABOVE_XY: "assets/news/USER_HAS_DAILY_RESULTS_ABOVE_XY.png",
  USER_HAS_HIGH_TICKET_ABOVE_XY: "assets/news/USER_HAS_HIGH_TICKET_ABOVE_XY.png",
  USER_ORDERED_IN_SHOP: "assets/news/USER_ORDERED_IN_SHOP.png",
  USER_PUBLISHED_BEFOREAFTER: "assets/news/USER_PUBLISHED_GALLERY.png",
  USER_PUBLISHED_GALLERY: "assets/news/USER_PUBLISHED_GALLERY.png",
  USER_PUBLISHED_JOB_OFFER: "assets/news/USER_PUBLISHED_TEAM_MEMBER.png",
  USER_PUBLISHED_NEWS_ENTRY: "assets/news/USER_PUBLISHED_NEWS_ENTRY.png",
  USER_PUBLISHED_TEAM_MEMBER: "assets/news/USER_PUBLISHED_TEAM_MEMBER.png",
  USER_RECEIVED_5_STAR_REVIEW: "assets/news/USER_RECEIVED_5_STAR_REVIEW.png",
  USER_UPDATED_PRICE_LIST: "assets/news/USER_UPDATED_PRICE_LIST.png",
  WOWFAMILY_PUBLISHED_EVENT: "assets/news/EVENT_REGISTRATION.png",
};

@Pipe({ name: "getNewsImage" })
export class GetNewsImagePipe implements PipeTransform {
  public transform(news: NewsDto): string {
    if (news.relatedTo?.avatar) return news.relatedTo.avatar;
    if (CATEGORY_IMAGES[news.type]) return CATEGORY_IMAGES[news.type];

    return "assets/icon/apple-touch-icon.png";
  }
}
